import React, { useContext, useState, useEffect } from "react";
import { history } from "service/helpers";
import { useDispatch } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton, AccordionContext } from "react-bootstrap";
import { NormalButton } from "component/common/NormalButton";
import greyArrow from "assets/svg/darkArrow.svg";
import greyArrowLeft from "assets/svg/darkArrow-left.svg";
import addIcon from "assets/svg/addIcon.svg";
import hideCollapse from "assets/svg/hideCollapse.svg";
import orangeCircleOne from "assets/svg/TawuniyaOrangeCircleOne.svg";
import orangeCircleTwo from "assets/svg/TawuniyaOrangeCircleTwo.svg";
import RightArrowIcon from "assets/images/menuicons/right-arrow.svg";
import "./style.scss";
import { getI18n, useTranslation } from "react-i18next";
import * as actions from "action/reportAction";
import { isEmpty } from "lodash";

function CustomToggle({ children, eventKey, callback }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));
  const isCurrentEventKey = activeEventKey === eventKey;
  const { i18n, t } = useTranslation(); return (
    <button type="button" className="addButton" onClick={decoratedOnClick}>
      <div className="d-flex flex-row align-items-center py-3">
        <div className="icon-wrapper d-flex align-items-center">
          <img
            src={isCurrentEventKey ? hideCollapse : addIcon}
            className="img-fluid accordionCollapseIcon"
            alt="icon"
          />
        </div>
        <div className="faq-q">{children}</div>
      </div>
    </button>
  );
}

export const Faq = ({
  faqData,
  faqData2,
  faqContainerData,
  viewAll = true,
  title,
  description,
  faqHeaderClass,
  faqParaClass,
  isDivClass = false,
  translation = false,
  isMotor = false,
  isHealth = false,
  isPandC = false,
  faqId,
  topSpace,
  viewButtonPlacement,
  blackColor,
  isFullWidth
}) => {

  const { i18n, t } = useTranslation();
  const currentLanguage = getI18n().language;
  const dispatch = useDispatch();
  const isRTL = i18n.dir() === "rtl";
  const columnClass = isFullWidth
    ? "col-md-12"  
    : isDivClass
      ? "col-lg-6 col-md-12"
      : "col-md-12 col-lg-6 pb-2";

  const navLinks = [
    {
      id: 0,
      linkName: "/individuals/customer-service/medical-fraud",
    },
    {
      id: 1,
      linkName: "/individuals/customer-service/motor-fraud",
    },
    {
      id: 2,
      linkName: "/individuals/customer-service/travel-fraud",
    },
  ];

  const [removeLnk, setRemoveLnk] = useState(true);

  useEffect(() => {
    const routeLnk = history.location.pathname;
    if (routeLnk === "/individuals/customer-service/service-category") {
      setRemoveLnk(false);
    } else if (routeLnk === "/individuals/customer-service") {
      setRemoveLnk(false);
    } else if (routeLnk === "/home-insurance/motor") {
      setRemoveLnk(false);
    } else if (routeLnk === "/individuals/customer-service/service-questions") {
      setRemoveLnk(false);
    }
  }, [removeLnk]);

  const handleButtonClick = () => {
    if (isMotor || isHealth || isPandC) {
      dispatch(
        actions.setReportPage(isMotor ? "motorFraud" : isHealth ? "medicalFraud" : "travelFraud")
      );
    }
    history.push("/individuals/customer-service/report-fraud");
  };

  return (
    <div className="row faqContainer" id={faqId}>
      {removeLnk && (
        <div className={`${title ? null : topSpace ? topSpace : "pt-1"} col-lg-12 col-12`}>
          <p
            className={
              title ? faqHeaderClass : `fw-800 ${window.innerWidth > 950 && "text-center"} faqTitle m-0`
            }
          >
            {title ? title : t("carAccidentFaq.title")}
          </p>
          <div className={description && "d-flex justify-content-center"}>
            <div>
              <p
                className={
                  description
                    ? faqParaClass
                    : `fs-16 fw-400 ${window.innerWidth > 950 && "text-center"} faqPara pb-3`
                }
              >
                {description ? description : t("carAccidentFaq.description")}
              </p>
            </div>
          </div>
        </div>
      )}
      <div className="col-lg-12 col-12">
        <div className="row">
          <div className="col-12">
            <div className="row">
              {faqData.map((item, index) => {
                return (
                  <div className={columnClass} key={index}>
                    <div className="reportAccordionQuestion">
                      <Accordion defaultActiveKey="1">
                        <CustomToggle eventKey="0">
                          <p className="fs-18 fw-400 m-0 accordionQuestion">
                            {translation ? t(item.question) : item.question}
                          </p>
                        </CustomToggle>
                        <div>
                          <Accordion.Collapse eventKey="0">
                            <div className="pb-3">
                              <p
                                className={`fs-16 fw-400 p-3 reportAccordionAnswer ${
                                  blackColor ? "blackColor" : ``
                                }`}
                              >
                                {item.ul ? (
                                  <ul>
                                    {item.answers.map((answer, index) => (
                                      <li key={index}>
                                        {translation ? t(answer) : answer}
                                        {item.link && (
                                          <a href={item.link}>
                                            &nbsp;{t("CLICK_HERE")}
                                          </a>
                                        )}
                                        {item.nextAnswer && (
                                          <span className="fs-16 fw-400 d-block pt-4">
                                            {item.nextAnswer}
                                          </span>
                                        )}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <div>
                                    {Array.isArray(item.answers)
                                      ? item.answers.map((answer, index) => (
                                          <React.Fragment key={index}>
                                            <span>
                                              {translation ? t(answer) : answer}
                                              {item.link && (
                                                <a href={item.link}>
                                                  &nbsp;{t("CLICK_HERE")}
                                                </a>
                                              )}
                                            </span>
                                            <br />
                                          </React.Fragment>
                                        ))
                                      : item.answer && (
                                          <React.Fragment>
                                            <span>
                                              {translation
                                                ? t(item.answer)
                                                : item.answer}
                                              {item.answer2 ? (
                                                <a
                                                  className="rent-now d-flex align-items-center gap-1"
                                                  href="https://www.ejaro.com"
                                                  target="_blank"
                                                >
                                                  {" "}
                                                  {t("ejaro.answ_color")}{" "}
                                                </a>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            <br />
                                          </React.Fragment>
                                        )}
                                    {item.link && (
                                      <a href={item.link}>
                                        &nbsp;{t("CLICK_HERE")}
                                      </a>
                                    )}
                                    {item.nextAnswer && (
                                      <span className="fs-16 fw-400 d-block pt-4">
                                        {item.nextAnswer}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </p>
                            </div>
                          </Accordion.Collapse>
                        </div>
                      </Accordion>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              {!isEmpty(faqData2) &&
                faqData2.map((item, index) => {
                  return (
                    <div
                      className={`${isDivClass ? "col-lg-6 col-md-12" : "col-md-12"} col-lg-6 pb-2`}
                      key={index}
                    >
                      <div className="reportAccordionQuestion">
                        <Accordion defaultActiveKey="1">
                          <CustomToggle eventKey="0">
                            <p className="fs-18 fw-400 pt-3 accordionQuestion">
                              {translation ? t(item.question) : item.question}
                            </p>
                          </CustomToggle>
                          <div>
                            <Accordion.Collapse eventKey="0">
                              <div className="pb-3">
                                <p className="fs-16 fw-400 p-3 reportAccordionAnswer">
                                  {Array.isArray(item.answers) ? (
                                    item.answers.map((answer, index) => (
                                      <React.Fragment key={index}>
                                        <span>
                                          {translation ? t(answer) : answer}
                                        </span>
                                        <br />
                                      </React.Fragment>
                                    ))
                                  ) : (
                                    item.answer && (
                                      <React.Fragment>
                                        <span>
                                                                            {Array.isArray(item.answers) ? (
                                    item.answers.map((answer, index) => (
                                      <React.Fragment key={index}>
                                        <span>
                                          {translation ? t(answer) : answer}
                                        </span>
                                        <br />
                                      </React.Fragment>
                                    ))
                                  ) : (
                                    item.answer && (
                                      <React.Fragment>
                                        <span>
                                          {translation ? t(item.answer) : item.answer}
                                        </span>
                                        <br />
                                      </React.Fragment>
                                    )
                                  )}
                                        </span>
                                        <br />
                                      </React.Fragment>
                                    )
                                  )}

                                  {item.nextAnswer && (
                                    <span className="fs-16 fw-400 d-block pt-4">{item.nextAnswer}</span>
                                  )}
                                </p>
                              </div>
                            </Accordion.Collapse>
                          </div>
                        </Accordion>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      {navLinks.map((item, index) => {
        return (
          <React.Fragment>
            {history.location.pathname === item.linkName && (
              <div className="col-lg-12 col-12 pt-5 pb-4" key={index}>
                <div className="orangeContainerLining pb-4">
                  <img src={orangeCircleOne} className="img-fluid orangeCircleOne" alt="circle" />
                  <img src={orangeCircleTwo} className="img-fluid orangeCircleTwo" alt="circle" />
                  <div className="orangeContainer">
                    <div className="row">
                      {faqContainerData.map((item, index) => {
                        return (
                          <React.Fragment>
                            <div className="col-lg-9 col-md-9 col-12" key={index}>
                              <p className="fraudServiceTitle m-0 pb-2">
                                {translation ? t(item.serviceTitle) : item.serviceTitle}
                              </p>
                              <p className="fraudServicePara">
                                {translation ? t(item.servicePara) : item.servicePara}
                              </p>
                            </div>
                            <div className="col-lg-3 col-12">
                              <div className="d-flex justify-content-lg-end pb-lg-0 pb-4">
                                <div>
                                  <NormalButton
                                    label={t("custm_medical.faq.start_btn")}
                                    className="reportButton p-lg-4"
                                    needBtnPic={true}
                                    adjustIcon="px-3"
                                    src={currentLanguage === "ar" ? greyArrowLeft : greyArrow}
                                    onClick={handleButtonClick}
                                  />
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      })}
      {/* {viewAll && (
        <div className={`view-all-wrapper ${viewButtonPlacement}`}>
          <div className="view-all">
            <div className="view-all-questions">
              <span className="view-all-text">{t("motorPageData.motorPageFaqs.viewAll")}</span>
              <img className="view-all-image" src={RightArrowIcon} alt="view all" />
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};
